import {useMutation, useQuery} from "react-query";
import {LOGOUT, VALIDATE_LOGIN, VALIDATE_TOKEN} from "./utils/constants";
import {validateLogin} from "../api/queries/auth";
import {requestAccess} from "../api/mutations/auth";
import Storage from "../utils/Storage";
import axios from "axios";
import {logout} from "../actions/authActions";
import { userTypes } from '../utils/constants';
import { setIntegrationsEnabled } from "../redux/reducers/auth";
import { useDispatch } from "react-redux";

export const useValidateLogin = (options = {}) => {
  const dispatch = useDispatch();

  const { enabled: enabledProp = true, ...restOptions } = options;

  return useQuery(VALIDATE_LOGIN, validateLogin, {
    retry: false,
    staleTime: Infinity,
    enabled: enabledProp && Boolean(Storage.token), // 👈 controlled by caller
    onSuccess: (res) => {
      const companyId = res?.user?.currentCompanyId || null;

      if (res.user.user_type !== userTypes.PROVIDER) {
        // ROAR-4850: company_id is no longer sent as an auth-trust header for customer-tier
        // requests — backend (ROAR-4801) derives customer scope server-side now. Storage is
        // still written: ~28 other files read it for non-auth UI/query-param logic.
        Storage.encryptStorageData('company_id', JSON.stringify({ id: companyId }));
      }

      Storage.setGenpt(res.user.genpt_enabled || false);
      Storage.setEasm(res.user.easm_enabled || false);
      Storage.setGithub(res.user.is_github_enabled || false);

      dispatch(
        setIntegrationsEnabled({
          is_genpt_enabled: res?.user?.is_genpt_enabled || false,
          is_github_enabled: res?.user?.is_github_enabled || false,
        })
      );
    },
    onError: (e) => {
      if (e?.response?.status === 401) {
        logout();
      }
    },
    ...restOptions, // allow overrides (e.g. staleTime) if needed
  });
};

export const useFetchUserDataFromToken = (options = {}) => {
    const {
      token = '',
      ...queryOptions
  } = options
    return useQuery(VALIDATE_TOKEN, async () => {
      let res = await axios.get(`/auth/validate_token`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
      return res.data
    }, {
      enabled: !!token,
      ...queryOptions
    })
  };

export const useLogout = () => {
    return useMutation(async () => {
        let res = await axios.post('/auth/logout')
        return res.data
    }, {
        mutationKey: LOGOUT,
        onSuccess: (res) => {
            if (res?.success)
                logout()
        }
    })
}

export const useUserRole = () => {
    const {data} = useValidateLogin()
    return data?.user?.role
}

export const useRequestAccess = () => {
    return useMutation(requestAccess)
}
